import { render, staticRenderFns } from "./ProductItemFeatureDelete.vue?vue&type=template&id=cba9009c&"
import script from "./ProductItemFeatureDelete.vue?vue&type=script&lang=js&"
export * from "./ProductItemFeatureDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports